import { show, hide, hideAll } from "../../utils/domUtils.js";
import { showLoading } from "../../helperFunctions.js";
import { modifyPdf, clearSignature } from "../../datenueberlassung.js";
import { setUserTypeCookie } from "../../cookieFunctions.js";
import { switchToSearchFilter } from "../../searchFilterFunctions.js";
import { showDeletedTrees } from "../../deletedTreesFunctions.js";
import * as htmlContent from "../../htmlContent.js";
import DataTable from "datatables.net-dt";

function showOnlyContent(targetId) {
  hideAll(...document.querySelectorAll(".contentContainer"));
  show(document.getElementById(targetId));
}

function toggleModal(selector) {
  const el = document.querySelector(selector);
  if (el) bootstrap.Modal.getOrCreateInstance(el).toggle();
}

export function initUIEventHandler() {
  // PDF-Datenüberlassung
  const submitButton = document.getElementById("submitAdressButton");
  submitButton.addEventListener("click", modifyPdf, false);

  const clearSignatureButton = document.getElementById("clearSignature");
  clearSignatureButton.addEventListener("click", clearSignature, false);

  document.getElementById("datenueberlassungButton").onclick = function () {
    showOnlyContent("datenueberlassungContainer");
  };

  // Ausschreibungsformulare
  document.getElementById("ausschreibungsformulareButton").onclick = function () {
    showOnlyContent("ausschreibungsformulareContainer");
  };

  // Experten-Willkommensmodal
  document.getElementById("expertUserButton").onclick = function () {
    bootstrap.Modal.getInstance(document.getElementById("staticBackdrop"))?.hide();
    setUserTypeCookie("ExpertUser");
    switchToSearchFilter();
  };

  // Straßenbaum-Liste (GALK)
  document.getElementById("galkListeButton").onclick = function () {
    hideAll(...document.querySelectorAll(".contentContainer"));
    document.getElementById("galkTableDiv").innerHTML = htmlContent.getGalkListContent();
    show(document.getElementById("galkListContainer"));

    new DataTable("#galkListTable", {
      info: true,
      ordering: true,
      paging: true,
      searching: true,
      autoWidth: true,
      lengthChange: true,
      scrollX: true,
    });
  };

  // Gefällte Bäume
  document.getElementById("gefaellteBaeumeButton").onclick = async function () {
    showOnlyContent("gefeallteBaeumeContainer");
    showLoading(true);
    await showDeletedTrees();
    showLoading(false);

    new DataTable("#gefaellteBaeumeDataTable", {
      info: true,
      ordering: true,
      paging: true,
      searching: true,
      autoWidth: true,
      lengthChange: true,
      scrollX: true,
    });
  };

  // Expertensuche
  document.getElementById("showTagSearchButton").onclick = function () {
    hideAll(...document.querySelectorAll(".contentContainer"));
    switchToSearchFilter();
  };

  // Daten-Tabelle anzeigen / verbergen
  document.getElementById("showDataTableButton").onclick = function () {
    show(document.getElementById("data-table"));
  };
  document.getElementById("dataTableCloseButton").onclick = function () {
    hide(document.getElementById("data-table"));
  };
  // Panel-Close-Buttons
  document.getElementById("tagSearchCloseButton").onclick = function () {
    hide(document.getElementById("SearchFilterContainer"));
  };
  document.getElementById("galkTableCloseButton").onclick = function () {
    hide(document.getElementById("galkListContainer"));
  };
  document.getElementById("gefaellteBaeumeCloseButton").onclick = function () {
    hide(document.getElementById("gefeallteBaeumeContainer"));
  };

  // Generische Close-Tab-Buttons (fügen d-none zum Elternelement hinzu)
  document.querySelectorAll(".closeTabButton").forEach(function (btn) {
    btn.addEventListener("click", function () {
      btn.parentElement.classList.add("d-none");
    });
  });

  // Welcome-Modal schließen
  document.querySelectorAll(".closeWelcomeModalX, #closeWelcomeModalButton").forEach(function (el) {
    el.addEventListener("click", function () {
      setUserTypeCookie("noHelp");
    });
  });

  // Navigations-Modals (Impressum, Standort, Kontakt, Datenschutz)
  document.querySelectorAll(".impressumLink").forEach(function (el) {
    el.addEventListener("click", function () { toggleModal(".impressumModal"); });
  });
  document.querySelectorAll(".standortLink").forEach(function (el) {
    el.addEventListener("click", function () { toggleModal(".standortModal"); });
  });
  document.querySelectorAll(".kontaktLink").forEach(function (el) {
    el.addEventListener("click", function () { toggleModal(".kontaktModal"); });
  });
  document.querySelectorAll(".datenschutzLink").forEach(function (el) {
    el.addEventListener("click", function () {
      document.querySelector(".modal-body-datenschutz").innerHTML = htmlContent.getDatenschutzContent();
      toggleModal(".datenschutzModal");
    });
  });
}
